/**
 * QuickBooks API — customers.
 * Delegates to client.js; returns raw Response for unchanged caller behavior.
 */

import { request } from "./client";

export function getCustomers() {
  return request("/qb/customers", { method: "GET" });
}
